export default __webpack_public_path__ + "static/media/SopCountImg.5d73c606.svg";